<ion-content class="recadinho-content" [scrollY]="false">

  <div class="sheet-grabber"></div>

  <div class="sheet-header">
    <img src="assets/imgs/icon-elogio.svg" class="header-icon" alt="">
    <div class="sheet-title">{{'writeRecadinhoTo' | translate}} {{soulName}}</div>
    <ion-icon name="close" class="close-btn" (click)="dismiss()"></ion-icon>
  </div>

  <!-- Miniatura da foto que está sendo elogiada -->
  <div class="context-card" *ngIf="photoUrl">
    <div class="context-texts">
      <div class="context-title">{{'replyLabel' | translate}}</div>
      <div class="context-sub">{{'toThisPersonsPhoto' | translate}}</div>
    </div>
    <img class="context-photo" src="{{photoUrl}}" alt="{{soulName}}">
  </div>

  <form [formGroup]="myForm" class="input-row">
    <img *ngIf="myPic" class="my-avatar" src="{{myPic}}" alt="">

    <!-- Gravando: ponto pulsante + tempo restante + parar -->
    <div *ngIf="isRecording" class="rec-state">
      <span class="rec-dot"></span>
      <span class="rec-time">{{ recElapsed }}s</span>
    </div>

    <!-- Áudio gravado: chip com ouvir + duração + descartar -->
    <div *ngIf="!isRecording && hasAudio" class="audio-chip">
      <ion-button class="play-btn" fill="clear" size="small" (click)="togglePreview()"
        [attr.aria-label]="(isPreviewPlaying ? 'pause' : 'play') | translate">
        <ion-icon [name]="isPreviewPlaying ? 'pause' : 'play'" slot="icon-only"></ion-icon>
      </ion-button>
      <span class="audio-dur">{{ audioDuration }}s</span>
      <ion-button class="discard-btn" fill="clear" size="small" (click)="discardAudio()"
        [attr.aria-label]="'delete' | translate">
        <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </div>

    <!-- Texto (padrão) -->
    <ion-textarea *ngIf="!isRecording && !hasAudio" autoGrow="true" rows="1" autocomplete="on" autocorrect="on"
      placeholder="{{'sendYourRecadinho' | translate}}"
      formControlName="msgControl"></ion-textarea>

    <!-- Microfone: iniciar (texto) ou parar (gravando) -->
    <!-- Microfone: só quando não há texto nem áudio — mesmo comportamento do chat,
         onde o mic some assim que o usuário começa a digitar. Durante a gravação
         ele permanece, virando o botão de parar. -->
    <ion-button *ngIf="!hasAudio && (isRecording || !hasText)" class="mic-btn" [class.recording]="isRecording"
      shape="round" size="small"
      (click)="toggleRecord()" [attr.aria-label]="(isRecording ? 'save' : 'record') | translate">
      <ion-icon [name]="isRecording ? 'stop' : 'mic'" slot="icon-only"></ion-icon>
    </ion-button>

    <!-- Enviar: aparece com texto, com áudio gravado ou durante a gravação.
         Ao abrir o modal, vazio, só o microfone fica visível. -->
    <ion-button *ngIf="hasText || hasAudio || isRecording" class="send-btn" shape="round" size="small"
      [disabled]="!canSend()" (click)="send()">
      <ion-icon *ngIf="!uploading" name="send" slot="icon-only"></ion-icon>
      <ion-spinner *ngIf="uploading" name="crescent"></ion-spinner>
    </ion-button>
  </form>

  <!-- Texto do produto (spec): dinâmico conforme já curtiu ou não -->
  <!-- Caption do preço: some quando já é match; e sempre "Enviar um elogio..." (sem "Curtir e"). -->
  <div class="price-caption" *ngIf="!alreadyLiked">
    {{ 'sendRecadinhoTo' | translate }}
    {{soulName}} {{'forOneCarrot' | translate}}
  </div>

</ion-content>
